<article class="text-and-blocks-block" [ngClass]="variantClass">
  <vtmn-play-icon
    *ngIf="hasIcon"
    class="text-and-blocks-block__icon"
    [name]="iconName"
  ></vtmn-play-icon>
  <picture
    *ngIf="hasImage"
    class="text-and-blocks-block__picture"
    [ngClass]="imageFormatVariantClass"
  >
    <img
      *ngIf="hasImage"
      class="text-and-blocks-block__image"
      [src]="block.image.url"
      [alt]="block.image.alternativeText"
      loading="lazy"
    />
  </picture>

  <h3 class="title-5 text-and-blocks-block__title">{{ block.title }}</h3>

  <div
    class="text-and-blocks-block__content"
    [innerHtml]="block.content | safeHtml"
  ></div>

  <app-cms-link
    *ngIf="hasLink"
    class="text-and-blocks-block__button"
    [text]="block.link_label"
    [url]="block.link_url"
    [isExternalLink]="block.is_external_link"
    [variant]="vtmnPlayButtonVariant.PRIMARY"
    [shape]="vtmnPlayButtonShape.ROUNDED"
  ></app-cms-link>
</article>
